import * as React from 'react';
import styles from './DeviceInfo.module.sass';

export interface IProps {
	children?: any;
}

export default function Footer(props: IProps) {
	return (
		<div className={styles.content}>
			<div>{props.children}</div>
		</div>
	);
}
